import { graphql, useFragment } from "react-relay"
import { UserAvatarTooltip } from "@/components/avatar-user-tooltip"
import { UserProvider } from "@/components/user-wrapper"
import { appointmentDrawerStatusIndicator_appointment$key } from "@/modules/common/waiting-room/appointment/__generated__/appointmentDrawerStatusIndicator_appointment.graphql"
import { AppointmentClosedStatusIndicator } from "@/modules/waiting-room/components/appointment-closed-status-indicator"
import { AppointmentEditStatusIndicator } from "@/modules/waiting-room/components/appointment-edit-status-indicator"

const AppointmentDrawerStatusIndicatorFragment = graphql`
  fragment appointmentDrawerStatusIndicator_appointment on Appointment {
    id
    isCompleted
    completedAt
    takenBy
    status
    patient {
      patientFileLock {
        lockedAt
        lockedBy
      }
    }
  }
`

interface Props {
  appointmentRef: appointmentDrawerStatusIndicator_appointment$key
}

const AppointmentDrawerStatusIndicator = ({ appointmentRef }: Props) => {
  const { id, isCompleted, takenBy, completedAt, patient, status } =
    useFragment<appointmentDrawerStatusIndicator_appointment$key>(
      AppointmentDrawerStatusIndicatorFragment,
      appointmentRef,
    )
  const { lockedAt, lockedBy } = patient.patientFileLock

  return (
    <div className="mr-auto flex items-center gap-2 text-ellipsis">
      {isCompleted && (
        <>
          <UserProvider
            userName={takenBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={`status-last-updated-by-${id}`} />}
          />
          <AppointmentClosedStatusIndicator completedAt={completedAt} isCancelled={status === "CANCELLED"} />
        </>
      )}
      {!isCompleted && lockedBy && (
        <>
          <UserProvider
            userName={lockedBy}
            render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier={`status-last-updated-by-${id}`} />}
          />
          <AppointmentEditStatusIndicator lockedAt={lockedAt} />
        </>
      )}
    </div>
  )
}

export { AppointmentDrawerStatusIndicator }
